import Nullstack from 'nullstack';
export default function IconBriefcaseOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-briefcase-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 7h8a2 2 0 0 1 2 2v8m-1.166 2.818a1.993 1.993 0 0 1 -.834 .182h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
  }), "   ", Nullstack.element("path", {
    d: "M8.185 4.158a2 2 0 0 1 1.815 -1.158h4a2 2 0 0 1 2 2v2"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v.01"
  }), "   ", Nullstack.element("path", {
    d: "M3 13a19.998 19.998 0 0 0 11.905 1.928m3.263 -.763a20.003 20.003 0 0 0 2.832 -1.165"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}